<template>
  <app-layout>
    <template #header>
      <div v-if="complaintSubmittable" class="md:flex text-left items-center">
        <div>
          <h1 class="text-2xl">Leergutreklamation</h1>
          <p class="text-base">Für meine Bestellung vom <b>{{ $page.props.formattedOrderDate }}</b>, KW {{ $page.props.weekOfYear }}</p>
        </div>
        <Link :href="route('complaint-index', { order })" class="button-secondary ml-auto mt-8 md:mt-0">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 17l-5-5m0 0l5-5m-5 5h12" />
          </svg>
          Zurück
        </Link>
      </div>
      <div v-else>
        <div class="max-w-5xl mx-auto text-center text-lg px-4 py-4 bg-yellow-200 mb-4">
          <b>Reklamation für die Bestellung am {{ $page.props.formattedOrderDate }} nicht möglich:</b><br>
          <p>Wir nehmen Reklamationen nur am Liefertag bis {{ complaintSubmittableTill }} Uhr entgegen.</p>
        </div>
        <Link :href="route('complaint-index', { order })" class="button-secondary ml-auto mt-8 md:mt-0">
          Zur Reklamationsübersicht
        </Link>
      </div>
    </template>

    <div v-if="complaintSubmittable" class="max-w-7xl py-6 px-4 sm:px-6 lg:px-8 mx-auto">
      <form
        class="lg:flex"
        @submit.prevent="submitComplaint">
        <div class="w-full lg:w-2/4 lg:pr-6 mb-8">
          <div class="pl-0 md:pl-4 lg:pl-8">
            <OrderPosition
              class="mb-4"
              v-for="item in $page.props.depositProducts"
              :key="item.id"
              :item="item"
              :isDepositProduct="true"
              @remove="() => onRemoveOrderPosition(item.id)"
              @update="onAddOrderPosition" />
          </div>
        </div>
        <div class="w-full lg:w-2/4 lg:pl-6">
          <div class="p-4 md:p-6 bg-gray-fill sticky top-0">
            <ProductComparisonTable
              :selected="form.product_claims"
              :products="$page.props.depositProducts"
              :isDepositForm="true"
              class="mb-8" />

            <div class="mt-8">
              <label
                class="text-base block mb-1 font-semibold"
                for="message">
                Kommentar <span class="opacity-50">(optional)</span>
              </label>
              <textarea
                v-model="form.message"
                id="message"
                class="block w-full"
                name="message"
                rows="5"
                maxlength="2000"
              ></textarea>
            </div>
            <p class="my-6 flex items-start text-accent-brown text-sm">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 flex-none mt-1 mr-1" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
              </svg>
              Reklamieren Sie bitte zum Absenden mindestens ein Pfand-Produkt.
            </p>
            <button
              type="submit"
              :disabled="!submittable"
              class="link-button-primary-lg mt-8">
              Reklamation übermitteln
            </button>
          </div>
        </div>
      </form>
    </div>
  </app-layout>
</template>

<script>
import{ Link } from "@inertiajs/inertia-vue3"

import AppLayout from '@/Layouts/AppLayout'
import ProductComparisonTable from '@/Components/Complaint/ProductComparisonTable'
import OrderPosition from '@/Components/Complaint/OrderPosition'

export default {
  components: {
    AppLayout,
    Link,
    ProductComparisonTable,
    OrderPosition
  },

  data() {
    return {
      form: this.$inertia.form({
        _method: 'POST',
        type: 'deposit',
        product_claims: [],
        message: null,
      })
    }
  },

  computed: {
    order() {
      return this.$page.props.order
    },

    messageValid() {
      return this.form.message !== null && this.form.message.length > 0
    },

    productsValid() {
      if (this.form.product_claims !== null && this.form.product_claims.length !== 0) {
        for (const claim of this.form.product_claims) {
          if (claim.difference === null || claim.difference === 0) {
            return false
          }
        }

        return true
      }
      return false
    },

    submittable() {
      return this.productsValid
    },

    complaintSubmittable() {
      return this.$page.props.complaintSubmittable
    },

    complaintSubmittableTill() {
      return this.$page.props.complaintSubmittableTill
    }
  },

  methods: {
    onRemoveOrderPosition (id) {
      const index = this.getIndexIfProductClaimById(id)

      if (index !== -1) {
        this.form.product_claims.splice(index, 1)
      }
    },

    onAddOrderPosition({ id, difference }) {
      const index = this.getIndexIfProductClaimById(id)

      if (index === -1) {
        this.form.product_claims.push({ id, difference })
      } else {
        this.form.product_claims[index] = { id, difference }
      }
    },

    getIndexIfProductClaimById(id) {
      return this.form.product_claims ? this.form.product_claims.findIndex(item => {
        return item.id === id
      }) : null
    },

    submitComplaint() {
      const { order, submittable } = this

      if (! submittable) {
        return
      }

      this.form.post(route('store-complaint', { order }), {
        errorBag: 'submitComplaint',
        preserveScroll: false
      });
    },
  },
}
</script>
